import { Body } from '@hover/blueprint';
import React from 'react';
import { PRICING_PREMIUM_TOOLTIPS } from '../../../../constants';
import ArrowButton from '../../../ui/ArrowButton';
import PricingTooltipsList from '../PricingTooltipsList';

const PremiumFeatures: React.FC = () => (
  <>
    <Body
      ml={500}
      fontWeight={400}
      fontStyle="italic"
      mt={500}
      mb="28px"
      size={300}
    >
      includes everything in Pay As You Go plus...
    </Body>
    <PricingTooltipsList data={PRICING_PREMIUM_TOOLTIPS} />
    <ArrowButton
      alignSelf="flex-start"
      colorScheme="primary"
      variant="minimal"
      sx={{
        // TODO(buttons): remove when we remove padding in Blueprint
        div: { pl: 0, pr: 50 },
      }}
      my={600}
      ml={500}
      onClick={() => {
        if (typeof document !== 'undefined') {
          const element = document.getElementById(
            'choose-plan-best-fits-your-team',
          );
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
            });
          }
        }
      }}
    >
      See discounts below
    </ArrowButton>
  </>
);

export default PremiumFeatures;
